export const DonationKey = "donation" as const;